import React from 'react'
import { Greeting, Widget } from '../../components'
import { LeaseTable } from '../lease/LeaseTable'
import './home.scss'

export const HomePage = () => {
  return (
    <div className="main">
      <div className="container">
        <div className="content">
          <div className="welcome">

            {/* heading */}
            <Greeting />
          </div>
          {/* overview cards */}
          <div className="widgets">
            <Widget type="properties" />
            <Widget type="tenant" />
            <Widget type="earning" />
            <Widget type="arrears" />

          </div>
          <div>
          <LeaseTable  title="All Trips" />
          </div>
        </div>
      </div>
    </div>
  )
}
